import { AsyncActionStatus } from "../../shared/abstractStore";
import { useAsyncCallback } from "react-use-async-callback";
import { useAccountService } from "./useAccountService";

/**
 * Callback to Send a password reset email.
 */
export function useSendPasswordResetEmailCallback(): [(email: string) => Promise<boolean>, AsyncActionStatus] {
    const accountService = useAccountService();

    const [action, { isExecuting, errors }] = useAsyncCallback(async (email: string) => {
        return await accountService.sendPasswordResetEmail(email);
    }, [accountService]);

    return [action, { isExecuting, errors }];
}
